import { AuthService } from 'src/app/shared/services/auth.service';
import { Component, OnInit, Output,Input, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ModalCodigoConductaComponent } from 'src/app/components/core/layouts/modal-codigo-conducta/modal-codigo-conducta.component';
import { CodigoConductaService } from './codigo-conducta.service';
import { TerminosCondicionesEntry } from 'src/app/shared/entrys/terminos-condiciones.entry';
import { DataSharedService } from 'src/app/shared/services/data-shared.service';
import { CompletaInformacionService } from '../completa-informacion/completa-informacion.service';
import { RNTPrestadorEntry } from 'src/app/shared/entrys/rnt-prestador.entry';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { EstablecimientoComercioService } from '../../establecimiento-comercio/establecimiento-comercio.service';
// tslint:disable-next-line:max-line-length
import { ModalConfirmacionSolicitudComponent } from 'src/app/components/core/layouts/modal-confirmacion-solicitud/modal-confirmacion-solicitud.component';
import { TipoPrestador } from 'src/app/shared/enumeraciones/tipo-prestador.enum';
import { DatoSolicitudSharedModel } from 'src/app/shared/models/dato-solicitud-shared.model';
import { TipoRnt } from 'src/app/shared/enumeraciones/tipo-rnt.enum';
import { AyudasService } from 'src/app/components/contenido/containers/ayudas/ayudas.service';
import { TipoSolicitud } from 'src/app/shared/enumeraciones/tipo-solicitud.enum';
import { PlataformasElectronicasDigitalesFlow } from 'src/app/shared/flows/plataformas-electronicas-digitales.flow';
import { IndicesPasosPlataformasDigitales } from 'src/app/shared/enumeraciones/indices-pasos-plataformas-digitales.enum';
import { ModalEncuestaRenovacionComponent } from 'src/app/components/core/layouts/modal-encuesta-renovacion/modal-encuesta-renovacion.component';
import { EstadosRnt } from 'src/app/shared/enumeraciones/estados-rnt.enum';
import { map, take } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import { SubcategoriaService } from '../../../administrador/configuracion/subcategoria/subcategoria.service';
import { BaseServiceService } from 'src/app/shared/services/base-service.service';
import { ActividadEconomicaEntry } from 'src/app/shared/entrys/actividad-economica.entry';
import { ModalValidarActividadesEconomicasComponent } from 'src/app/components/core/layouts/modal-validar-actividades-economicas/modal-validar-actividades-economicas.component';
import { SolicitudService } from '../../solicitudes/solicitud.service';
import { ModalCorreoMensajeComponent } from 'src/app/components/core/layouts/modal-correo-mensaje/modal-correo-mensaje.component';
import { ResultadoValidacionModel } from 'src/app/shared/models/resultado-validacion.model';
import { EstablecimientoEntry } from "src/app/shared/entrys/establecimiento.entry";

@Component({
	selector: 'app-codigo-conducta',
	templateUrl: './codigo-conducta.component.html',
	styleUrls: ['./codigo-conducta.component.scss']
})
export class CodigoConductaComponent implements OnInit {
	@Output()
	pasoActual: EventEmitter<number> = new EventEmitter();

	codigoConducta: TerminosCondicionesEntry;
	rnt: RNTPrestadorEntry;
	formCodigoConducta: FormGroup;
	boton: string;
	boton_atras: string;
	datoSolicitudSharedModel: DatoSolicitudSharedModel;

	constructor(private router: Router, private modalService: NgbModal,
		private codigoConductaService: CodigoConductaService, private dataSharedService: DataSharedService,
		private completaInformacionService: CompletaInformacionService, private formBuilder: FormBuilder,
		private establecimientoComercioService: EstablecimientoComercioService, private authService: AuthService,
		public ayudaService: AyudasService,
		private subCategoriaService: SubcategoriaService,
		private baseService: BaseServiceService,
		private solicitudService: SolicitudService
	) {
		this.codigoConducta = {} as TerminosCondicionesEntry;
		this.dataSharedService.data$.subscribe(resultado => {
			this.datoSolicitudSharedModel = resultado as DatoSolicitudSharedModel;
			this.rnt = this.datoSolicitudSharedModel.data as RNTPrestadorEntry;
		});
		this.formCodigoConducta = formBuilder.group({
			acepta_codigo_conducta: [false, Validators.requiredTrue]
		});
	}

	ngOnInit() {
		this.boton = 'Finalizar';
		this.boton_atras = 'Revisar';
        

		if (this.authService.getRolDetalleUser() === TipoPrestador.Guia &&
			this.datoSolicitudSharedModel.tipo_rnt !== TipoRnt.Inmuebles &&
			this.datoSolicitudSharedModel.tipo_rnt !== TipoRnt.PlataformaDigitales) {
			this.pasoActual.emit(4);
		} else if (this.authService.getRolDetalleUser() === TipoPrestador.Guia &&
			this.datoSolicitudSharedModel.tipo_rnt !== TipoRnt.PlataformaDigitales) {
			this.pasoActual.emit(4);
		} else if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.PlataformaDigitales) {
			this.pasoActual.emit(4);
		} else {
			if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Guia) {
				//this.pasoActual.emit(3);
				this.pasoActual.emit(4);
			} else {
				this.pasoActual.emit(4);
			}
		}
		if (this.datoSolicitudSharedModel.data.estado_rnt_id ===
			EstadosRnt.SuspendidoPorNoRenovar &&
			this.datoSolicitudSharedModel.tipo_solicitud ===
			TipoSolicitud.Reactivacion) {
			this.pasoActual.emit(5);

		}
		if ((this.datoSolicitudSharedModel.data.estado_rnt_id ===
			EstadosRnt.SuspendidoPorNoRenovar &&
			this.datoSolicitudSharedModel.tipo_solicitud ===
			TipoSolicitud.Reactivacion) ||
			(this.datoSolicitudSharedModel.tipo_solicitud ===
				TipoSolicitud.Renovacion && (this.rnt.tipo_rnt_id !== 2))) {
			this.boton = 'Siguiente';
			this.boton_atras = 'Atrás';

		}
		this.codigoConductaService.get(null).subscribe(resultado => {
			if (resultado.result) {
				this.codigoConducta = (resultado.data as Array<TerminosCondicionesEntry>)[0];
			}
		});
	}

	goPaso() {
		if (this.authService.getRolDetalleUser() === TipoPrestador.Guia && this.datoSolicitudSharedModel.tipo_rnt !== TipoRnt.Inmuebles) {
			this.rnt.paso = 4;
		} else {
			this.rnt.paso = 4;
			if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Guia) {
				this.rnt.paso = 4;
			} else {
				this.rnt.paso = 4;
			}
		}
		if ((this.datoSolicitudSharedModel.data.estado_rnt_id ===
			EstadosRnt.SuspendidoPorNoRenovar &&
			this.datoSolicitudSharedModel.tipo_solicitud ===
			TipoSolicitud.Reactivacion) ||
			(this.datoSolicitudSharedModel.tipo_solicitud ===
				TipoSolicitud.Renovacion && (this.rnt.tipo_rnt_id !== 2))) {
			this.rnt.paso = 5;
			this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
				data: { ...this.rnt },
				tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
				tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
				estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud
			});
			this.router.navigate(["/solicitud/fontur"]);
			return;
		}

		this.finalizar();
	}

	tieneEncuestaOpcional(): void {
		if (this.datoSolicitudSharedModel.tipo_solicitud !== TipoSolicitud.Renovacion &&
			!(this.datoSolicitudSharedModel.data.estado_rnt_id ===
				EstadosRnt.SuspendidoPorNoRenovar &&
				this.datoSolicitudSharedModel.tipo_solicitud ===
				TipoSolicitud.Reactivacion)) {
			this.router.navigate(['/mis-establecimientos']);
		} else {
			this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
				data: { ...this.rnt },
				tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
				tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
				estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud
			});
			this.onModalEncuesta();
		}
	}
	onModalEncuesta(): void {
		this.completaInformacionService
			.getParametro({
				parametro_id: "MENSAJE_MODAL_ENCUESTA_DE_TURISMO",
				agrupacion: "TRATAMIENTO_DATOS",
				auxiliar: "1",
			}).subscribe(response => {
				if (response.result) {
					const modalEncuestaRenovacionComponent = this.modalService.open(
						ModalEncuestaRenovacionComponent,
						{ centered: true, backdrop: "static", size: "md" }
					);
					modalEncuestaRenovacionComponent.componentInstance.mensaje = response.data;
					modalEncuestaRenovacionComponent.result
						.then(result => {
							this.router.navigate(['/solicitud/encuesta']);
						}).catch((_) => {
							this.router.navigate(['/mis-establecimientos']);
						});
				}
			});
	}
	onRegresarPaso(): void {
		if (this.authService.getRolDetalleUser() !== TipoPrestador.Guia) {
			this.rnt.paso = 4;
		} else {
			this.rnt.paso = 3;
		}

		if (this.datoSolicitudSharedModel.data.estado_rnt_id ===
			EstadosRnt.SuspendidoPorNoRenovar &&
			this.datoSolicitudSharedModel.tipo_solicitud ===
			TipoSolicitud.Reactivacion) {
			this.rnt.paso = 4;
		}

		this.rnt.acepta_codigo_conducta = false;
		this.completaInformacionService.update(this.rnt).subscribe(resultado => {
			if (resultado.result) {
				this.dataSharedService.sharedData(<DatoSolicitudSharedModel>{
					data: { ...this.rnt },
					tipo_solicitud: this.datoSolicitudSharedModel.tipo_solicitud,
					tipo_rnt: this.datoSolicitudSharedModel.tipo_rnt,
					estado_solicitud: this.datoSolicitudSharedModel.estado_solicitud
				});

				if (this.datoSolicitudSharedModel.tipo_solicitud === TipoSolicitud.Renovacion ||
					(this.datoSolicitudSharedModel.data.estado_rnt_id ===
						EstadosRnt.SuspendidoPorNoRenovar &&
						this.datoSolicitudSharedModel.tipo_solicitud ===
						TipoSolicitud.Reactivacion)) {
					this.router.navigate(['/solicitud/tipo-establecimiento']);
				} else {
					if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Inmuebles) {
						this.router.navigate(['solicitud/completa-informacion-inmueble']);
					} else {
						if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Guia) {
							this.router.navigate(['solicitud/completa-informacion-guia']);
						} else if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.Establecimiento) {
							this.router.navigate(['solicitud/completa-informacion']);
						} else if (this.datoSolicitudSharedModel.tipo_rnt === TipoRnt.PlataformaDigitales) {
							PlataformasElectronicasDigitalesFlow.conmutadorDePasosPlataformasDigitales(IndicesPasosPlataformasDigitales.CompletarInformacionPlataformas, this.router);
						}
					}
				}
			}
		});
	}

	private finalizar() {

		 let camaraAc = localStorage.getItem("keyCamaraID") !== null ? localStorage.getItem("keyCamaraID") : "";
		 let MatAc = localStorage.getItem("keyMatricula") !== null ? localStorage.getItem("keyMatricula") : "";

		 this.rnt.codigo_camaraestacti = camaraAc;
         this.rnt.matricula_estacti = MatAc;

		this.rnt.acepta_codigo_conducta = this.formCodigoConducta.value.acepta_codigo_conducta;
		this.completaInformacionService.update(this.rnt).subscribe(resultado => {
			if (resultado.result) {
				const modalRef = this.modalService.open(ModalCodigoConductaComponent, { centered: true });
				modalRef.result.then(() => {
					this.completaInformacionService.sendNotificar(this.rnt).subscribe(resultadoNotifica => {
						if (resultadoNotifica.result) {
							const modalFinalizar = this.modalService.open(ModalConfirmacionSolicitudComponent, { centered: true });
							modalFinalizar.componentInstance.mensaje = resultadoNotifica.data;
							modalFinalizar.result.then(() => {
								this.tieneEncuestaOpcional();
							}).catch(() => {
								this.tieneEncuestaOpcional();
							});
						} else if (resultadoNotifica.control?.code == 4114) {//4114 indica la respuesta es relacionada a errores de validacion
							try {
								const resultadoValidacion = JSON.parse(resultadoNotifica.data) as ResultadoValidacionModel;
								// if (resultadoValidacion.actividad_economica_valida == false)
								// 	this.mostrarErrorActividadEconomicaInvalida();
								if (resultadoValidacion.notificacion)
									this.mostrarNotificacionEnviada(resultadoValidacion.notificacion);
									this.reset_LocalStorage();
							} catch {
							}
						}
					});
				});
			}
		});
	}

	// private mostrarErrorActividadEconomicaInvalida() {
	// 	let $mensajeError = this.completaInformacionService
	// 		.getParametro({ parametro_id: "ADVERTENCIA_ACTIVIDAD_ECONOMICA_NO_CORRESPONDE_SUBCATEGORIA_PRESTADOR", agrupacion: "VALIDACIONES", auxiliar: "1", })
	// 		.pipe(map(resultado => resultado.result ? resultado.data : ""));

	// 	let $descripcionCorrespondenciaSubCategoria = this.subCategoriaService.getDescripcionCorrespondenciaCiiu(this.rnt.sub_categoria_id)
	// 		.pipe(map(resultado => resultado.data));

	// 	let $actividadesEconomicas = this.baseService.getActividadesEconomicasPrestador(this.authService.getUserNameToken())
	// 		.pipe(map(resultado => resultado.control.code == 200 ? resultado.data as ActividadEconomicaEntry[] : []));

	// 	forkJoin([$mensajeError, $descripcionCorrespondenciaSubCategoria, $actividadesEconomicas]).pipe(
	// 		take(1)
	// 	).subscribe(([mensajeError, descripcionCorrespondenciaSubCategoria, actividadesEconomicas]) => {
	// 		const modal = this.modalService.open(ModalValidarActividadesEconomicasComponent, { centered: true, backdrop: "static", size: "lg" });
	// 		modal.componentInstance.mensaje = mensajeError;
	// 		modal.componentInstance.descripcionCorrespondenciaSubCategoria = descripcionCorrespondenciaSubCategoria;
	// 		modal.componentInstance.actividadesEconomicas = actividadesEconomicas;
	// 	});
	// }

	private mostrarNotificacionEnviada(notificacion: string) {
		const modalRef = this.modalService.open(ModalCorreoMensajeComponent,
			{ centered: true, size: 'lg', backdropClass: 'light-blue-backdrop' });
		const entry = {
			contenido_mensaje: notificacion
		};
		modalRef.componentInstance.notificacion = entry;
	}

	reset_LocalStorage(){
		localStorage.removeItem("keyCamaraID");
		localStorage.removeItem("keyMatricula");
	  }
}
